import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@/components/atoms/Icon/Icon';
import { useEffect, useRef } from 'react';
import { useFocusManager } from 'react-aria';
export const MenuItem = ({ href, text, target, icon, className, ariaLabel, ariaExpanded, testid, onClick, isFocus, role, ...props }) => {
    const Element = href ? 'a' : 'button';
    const focusManager = useFocusManager();
    const refMenu = useRef(null);
    const onMenuItemKey = (event) => {
        if (event.key === 'ArrowDown') {
            focusManager?.focusNext({ wrap: true });
        }
        if (event.key === 'ArrowUp') {
            focusManager?.focusPrevious({ wrap: true });
        }
    };
    useEffect(() => {
        if (isFocus) {
            refMenu?.current?.focus();
        }
    }, [isFocus]);
    return (_jsxs(Element, { href: href, className: className, target: target, role: role, "aria-label": ariaLabel || text, "aria-expanded": ariaExpanded, onKeyUp: onMenuItemKey, "data-testid": testid, onClick: onClick, ref: refMenu, ...props, children: [icon && (_jsx("div", { className: "mr-0.5 flex h-1.5 w-1.5 items-center justify-center", "aria-hidden": "true", children: _jsx(Icon, { variant: icon, className: "h-3 w-4 object-contain" }) })), text] }));
};
